export enum InicioContagemTempoEnum {

  APOS_1_MES = "1 mês",
  APOS_VENCIMENTO = "Vencimento",
  APOS_VIRADA_MES = "Virada do mês"
}
